<template>
  <div class="container-fluid">
    <loading
      :active.sync="productLoading"
      :can-cancel="true"
      :is-full-page="true"
    >
    </loading>
    <div class="card">
      <div class="card-body">
        <button
          class="float-right btn btn-info btn-sm text-center ml-1"
          @click="handleBackToCustomer"
        >
          {{ $t("buttons.returnClient") }}
        </button>
        <h5 class="card-title text-muted">
          <strong>{{ $t("products.addProducts") }}</strong>
        </h5>
        <button
          class="btn btn-danger btn-sm text-center"
          @click="clearProductsBasket"
        >
          {{ $t("buttons.cleanBasket") }}
        </button>
        <search :term="searchTerm" @search="setSearchTerm" />
        <div class="table-responsive">
          <table class="table table-bordered table-striped p-2">
            <thead>
              <tr>
                <th scope="col">
                  {{ $t("products.description") }}
                </th>
                <th scope="col">
                  {{ $t("products.itemCode") }}
                </th>
                <th scope="col">
                  {{ $t("products.availableQuantity") }} /
                  {{ $t("products.quantityOnOrder") }}
                </th>
                <th scope="col">
                  {{ $t("products.availableQuantityLontex") }} /
                  {{ $t("products.lastPrice") }}
                </th>
                <th scope="col">
                  {{ $t("products.price") }} "/"
                  {{ $t("products.priceAfterDiscount") }}
                </th>
                <th scope="col">
                  {{ $t("products.quantityOpen") }}
                </th>
                <th scope="col">
                  {{ $t("products.qtyPallet") }}
                </th>
                <th scope="col">
                  {{ $t("products.qtyPackage") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="p in processedProducts"
                :key="p.id"
                class="m-1 p-1 bg-light"
              >
                <td class="">
                  <h6
                    style="cursor: pointer;margin-bottom:0px;"
                    @click="showProductInfo(p)"
                  >
                    {{ lang === "pl" ? p.name : p.descriptionEn }}
                  </h6>
                  <span style="font-size:12px;">
                    {{ p.asortment }}
                  </span>
                </td>
                <td class="form-group">
                  <h6>{{ p.sku }}</h6>
                </td>
                <td>
                  <span class="badge badge-pill badge-success float-left mb-3">
                    {{ p.stock }}
                  </span>
                  <span class="badge badge-pill badge-dark float-right mt-3">
                    {{ p.stockBlocked }}
                  </span>
                </td>
                <td>
                  <span class="badge badge-pill badge-info float-left mt-3">
                    {{ p.stockAvailability }}
                  </span>
                  <span class="badge badge-pill badge-warning float-right mb-3">
                    {{ currencyDisplay(p.lastPrice) }}
                  </span>
                </td>
                <td>
                  <span class="badge badge-pill badge-primary float-left mb-3">
                    {{ currencyDisplay(p.price) }}
                  </span>

                  <span class="badge badge-pill badge-success float-right mt-3">
                    {{
                      p.priceAfterDiscount > 0
                        ? currencyDisplay(p.priceAfterDiscount)
                        : currencyDisplay(p.priceAfterDiscount)
                    }}
                    <small
                      style="font-size: 80%"
                      class="badge badge-pill badge-Warning center"
                    >
                      {{
                        parseFloat(
                          (p.priceAfterDiscount / p.price) * 100
                        ).toFixed(3)
                      }}
                      %
                    </small>
                  </span>
                </td>
                <td>
                  <span class="badge badge-pill badge-light float-right mt-3">
                    {{ p.stockOpen }}
                  </span>
                </td>
                <td>{{ p.qtyPalette }}</td>
                <td>{{ p.qtyPackage }}</td>
                <td
                  v-if="checkIfCustomerExist()"
                  colspan="3"
                  class="text-center"
                >
                  <div v-if="checkExistInBasket(p)">
                    <button
                      class="btn btn-success btn-sm text-center"
                      @click="handleProductAdd(p)"
                    >
                      {{ $t("buttons.add") }}
                    </button>
                  </div>
                  <div v-else>
                    <button class="btn btn-light btn-sm text-center">
                      {{ $t("buttons.added") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <page-controls
            :number-of-pages="pageCount"
            :current-page="currentPage"
            @pageChange="setCurrentPage"
            @sizeChange="setPageSize"
          />
        </div>
        <div class="float-right">
          <router-link to="/cart" class="btn btn-primary m-1">
            {{ $t("buttons.nextStep") }}
          </router-link>
        </div>
      </div>
    </div>
    <product-info-modal
      :visible="isProductVisible"
      :product="showedProduct"
      @on-close="isProductVisible = !isProductVisible"
    />
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import PageControls from "../../components/PageControls";
import Search from "../../components/Search";
import { currencyMixin } from "../../mixins";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import i18n from "../../translations";
import ProductInfoModal from "../../components/ProductInfoModal";
import { ETollList } from "../../enums/ServicesProductsEToll";
import Vue from "vue";

export default {
  name: "ProductList",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      isProductVisible: false,
      showedProduct: null,
      eTollsList: ETollList,
    };
  },
  components: { PageControls, Search, Loading, ProductInfoModal },
  mixins: [currencyMixin],
  computed: {
    lang() {
      return i18n.locale;
    },
    ...mapGetters("products", [
      "processedProducts",
      "pageCount",
      "productLoading",
    ]),
    ...mapGetters("cart", ["currentCustomer"]),
    ...mapState("products", ["currentPage", "products", "searchTerm"]),
    ...mapState("cart", ["order"]),
  },
  mounted() {
    //  this.isLoading = true;
  },
  methods: {
    ...mapActions("products", ["getProductsToCardCode"]),
    ...mapActions("cart", ["addProduct", "backCustomer"]),
    ...mapMutations("products", [
      "setCurrentPage",
      "setPageSize",
      "setSearchTerm",
    ]),
    ...mapMutations("cart", ["setCartData"]),
    checkExistInBasket(product) {
      // let findProduct = this.order.lines.find(
      //   (p) => p.product.id === product.id
      // );
      let country = this.eTollsList.find(function(element) {
        return element.sku == product.sku ? true : false;
      });
      var hasMatch =
        this.order.lines.filter(function(p) {
          return p.product.id === product.id && p.status == "O";
        }).length > 0;

      if (hasMatch && country == null) {
        return false;
      }
      return true;
    },
    showProductInfo(p) {
      this.showedProduct = p;
      this.isProductVisible = true;
    },
    handleProductAdd(product) {
      this.addProduct(product);
      Vue.notify({
        group: "success",
        title: this.$t("buttons.addToCart"),
        text: product.name + " " + product.sku,
      });
    },
    clearProductsBasket() {
      this.setCartData([]);
      localStorage.removeItem("cart");
    },
    handleBackToCustomer() {
      let customer = JSON.parse(JSON.stringify(this.currentCustomer));
      if (Object.keys(customer).length > 0) {
        this.$router.push({
          name: "customer",
          params: {
            id: this.currentCustomer.customerId,
          },
        });
      } else {
        this.$router.push("/customers");
      }
    },
    checkIfCustomerExist() {
      if (this.currentCustomer.customerId) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
